import * as React from 'react';
import UrlHelpers from '../../shared/url_helpers';

export default () =>
  (<div className="align-center">
    <div className="mb-1">
      <h3 className="heading-3 halfmargined-bottom">
        {I18n.t('digitalListing.error.title')}
      </h3>
      <h3 className="heading-3">
        {I18n.t('digitalListing.error.explanation')}
      </h3>
    </div>

    <ul className="inline-list pb-6">
      <li className="extramargined-bottom">
        <a href={UrlHelpers.rootPath} className="btn btn-blue">
          {I18n.t('digitalListing.error.homePage')}
        </a>
      </li>
      <li className="ml-half">
        <a href="/page/contact" className="btn">
          {I18n.t('digitalListing.error.contactSupport')}
        </a>
      </li>
    </ul>
  </div>);



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/error.jsx